import { render, staticRenderFns } from "./SectionFeatures.vue?vue&type=template&id=306c15bd"
import script from "./SectionFeatures.vue?vue&type=script&lang=js"
export * from "./SectionFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports